import { render, staticRenderFns } from "./_Banners.vue?vue&type=template&id=3a530602&"
import script from "./_Banners.vue?vue&type=script&lang=js&"
export * from "./_Banners.vue?vue&type=script&lang=js&"
import style0 from "./_Banners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports